<nz-layout>
    <nz-content class="table-container">
        <div class="grid" [style.width]="'100%'" [style.backgroundColor]="'white'" [style.height]="'2.5rem'">
            <div class="row">
                <div class="column no-border" [style.width]="'10rem'">
                    <b>交工报检</b>
                </div>
                <div class="column no-border" [style.width]="'100px'">
                    <select class="color-primary background-module" [(ngModel)]="sectionId" [disabled]="true">
                        <option *ngFor="let item of sectionList" [value]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="column no-border" [style.width]="'26rem'" [style.justifyContent]="'flex-start'">
                    <nz-cascader class="color-primary" [nzShowSearch]="true" [nzOptions]="jgFbCascaderOptions"
                        [(ngModel)]="jgFbCascaderValue" (ngModelChange)="onFbCascaderValueChange()">
                    </nz-cascader>
                </div>
                <div class="column no-border" [style.width]="'90px'">
                    分项工程：
                </div>
                <div class="column no-border" [style.width]="'26rem'">
                    <select class="color-primary background-module" [(ngModel)]="fxItemId"
                        [disabled]="jgFbCascaderValue.length === 0" (ngModelChange)="onUnitFxItemChoose()">
                        <option [value]="0">请选择</option>
                        <option *ngFor="let item of jgPhysicalInspUnitFxList" [value]="item.id">
                            {{item.jgFxProjectTypeName}}[{{item.jgFxProjectTypeCode}}]/{{item.jgFxName}}
                        </option>
                    </select>
                </div>
                <div class="column no-border" [style.width]="'100px'">
                    起止里程桩号：
                </div>
                <div class="column no-border" [style.width]="'120px'">
                    <input [disabled]="!fxItem?.id" type="text" [(ngModel)]="mileStart" placeholder="输入起始里程桩号">
                </div>
                <div class="column no-border" [style.width]="'20px'">
                    ~
                </div>
                <div class="column no-border" [style.width]="'120px'">
                    <input [disabled]="!fxItem?.id" type="text" [(ngModel)]="mileEnd" placeholder="输入结束里程桩号">
                </div>
                <div class="column" [style.width]="'80px'">
                    <button nz-button nzType="primary" (click)="onLcSearch()" [disabled]="!fxItem?.id">查询</button>
                </div>
                <div class="column" [style.width]="'80px'">
                    <button nz-button nzType="primary" (click)="reset()" [disabled]="!fxItem?.id">复位</button>
                </div>
            </div>
        </div>
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro *ngIf="!!fxItem?.id" [config]="config!" [currentPage]="1" [currentPageSize]="1000"
                [tableData]="[]" [stickyTop]="40">

                <div class="grid overview" overview>

                    <div class="row">
                        <div class="column background-light" [style.textAlign]="'right'" [style.width]="'296px'">
                            <b>分项工程单元数筛选合计</b>
                        </div>
                        <div class="column background-light" [style.textAlign]="'left'" [style.width]="'140px'">
                            <b>{{currentTotal}}</b>
                        </div>
                        <div class="column background-light" [style.textAlign]="'right'"
                            [style.width]="isLM ? '440px' : '300px'">
                            <b>全选列表中所有工程部位的所有检测项目</b>
                        </div>
                        <div class="column background-light" [style.textAlign]="'right'" [style.width]="'30px'">
                            <input type="checkbox" [(ngModel)]="checkAll" (ngModelChange)="onCheckAllChange()">
                        </div>
                        <div class="column background-light" [style.textAlign]="'right'" [style.width]="'130px'">
                            <b>工程部位全选→</b>
                        </div>
                        <div class="column background-light" *ngFor="let item of unitConf;let index = index"
                            [style.textAlign]="'right'" [style.width]="'80px'">
                            <input type="checkbox" [(ngModel)]="columnCheckMap[item.jgInspItemName!]"
                                (ngModelChange)="onColumnCheckChange(index)">
                        </div>
                    </div>
                </div>

                <div body>
                    <table [style.left]="0" [style.width]="totalWidth + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let col of config?.columns ?? []"
                                [style.width]="(col.width * 100 / totalWidth) + '%'">
                        </colgroup>

                        <tr class="{{index < recordTable.length - 1 && (item.fullName + (item.partitionCode ?? '')) !== (recordTable[index + 1].fullName + (item.partitionCode ?? '')) ? 'border-bottom-black' : ''}}"
                            *ngFor="let item of recordTable ?? []; let index = index;">
                            <td [style.textAlign]="'center'">
                                {{index + (pager.pageIndex - 1) * pager.pageSize + 1}}</td>

                            <td class="border-bottom-black background-white" *ngIf="item.fbCode"
                                [rowSpan]="item.fbSpan ?? 1">
                                <span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
                            </td>
                            <td class="border-bottom-black background-white" *ngIf="item.subFbCode"
                                [rowSpan]="item.subFbSpan ?? 1">
                                <b> <span class="color-light">{{item.subFbCode}}</span>
                                    {{item.subFbName}}</b>

                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black' : 'border-right-black'}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                <p class="ellipsis" dPopover [content]="item.sectionCode + ' ' + item.sectionName"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="(item.sectionCode + ' ' + item.sectionName).length > 25"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    <span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
                                </p>
                            </td>
                            <td class="color-light text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                {{item.constructionOrgName}}
                            </td>

                            <td class="text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                {{item.code}}
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                <p *ngIf="!!item.mileage" class="ellipsis" dPopover [content]="item.mileage"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="item.mileage.length > 16"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    {{item.mileage}}
                                </p>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.constructionFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-primary">
                                    {{item.constructionFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.constructionFormCompleted">
                                    {{item.constructionFormCount}}
                                </span>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.superviseRecordFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-primary">
                                    {{item.superviseRecordFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted">
                                    {{item.superviseRecordFormCount}}
                                </span>
                            </td>
                            <td class="editable">
                                <format-data [contentStr]="item.comment?.toString() ?? ''" [patternStr]="'E+118'">
                                    <input type="text" [(ngModel)]="item.comment"
                                        (blur)="onBlur(item.id!, item.comment ?? '')" (click)="edit('comment' + index)"
                                        class="{{editing['comment' + index] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                            <td [style.textAlign]="'center'"
                                class="{{index <= 0 || item.asPrevDisabled ? 'color-light' : 'color-primary pointer'}} "
                                (click)="asPrev(index)">
                                同上
                            </td>
                            <td [style.textAlign]="'center'">
                                <input type="checkbox" [(ngModel)]="item.checkAll" [disabled]="!!item.checkAllDisabled"
                                    (ngModelChange)="onItemUnitCheckAllChange(index)">
                            </td>
                            <td *ngFor="let unit of item.jgPhysicalInspUnitItems ?? []; let col = index"
                                [style.textAlign]="'center'">
                                <input *ngIf="!unit.jgRfiWorkFlowKey" type="checkbox" [(ngModel)]="unit.checked"
                                    (ngModelChange)="onUnitCheckChange(index, col)">
                                <span *ngIf="unit.jgRfiWorkFlowKey"
                                    class="pointer link {{WorkReportStatusColorMap[unit.jgRfiStatus!]}}"
                                    (click)="sign(unit.jgRfiWorkFlowKey)">
                                    {{unit.jgRfiName}}
                                </span>
                            </td>
                        </tr>

                    </table>

                </div>
            </table-pro>
        </div>
    </nz-content>
    <nz-footer class="footer grid" *ngIf="!!fxItem?.id">
        <!-- TODO -->
        <div class="row">
            <div class="column btn-bar border-right-black" [style.width]="isLM ? '906px' : '766px'">
                <button nz-button nzType="primary" (click)="cancel()">取消</button>
                <button nz-button nzType="primary" (click)="confirm()" [disabled]="totalCheckedCount === 0">提交</button>
            </div>

            <div class="column" [style.textAlign]="'center'" [style.width]="'50px'">
                合计
            </div>
            <div class="column color-primary border-right-black" [style.textAlign]="'center'" [style.width]="'80px'">
                {{totalCheckedCount}}
            </div>
            <div class="column" *ngFor="let item of columnCheckCount" [style.textAlign]="'center'"
                [style.width]="'80px'">
                {{item}}
            </div>
        </div>

    </nz-footer>
</nz-layout>